import { render, staticRenderFns } from "./AppraisalSectionHeader.vue?vue&type=template&id=bfc2b16c&scoped=true"
import script from "./AppraisalSectionHeader.vue?vue&type=script&lang=js"
export * from "./AppraisalSectionHeader.vue?vue&type=script&lang=js"
import "./AppraisalSectionHeader.vue?vue&type=style&index=0&id=bfc2b16c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfc2b16c",
  null
  
)

export default component.exports